import { render, staticRenderFns } from "./ModelSetting.vue?vue&type=template&id=a4610324&scoped=true&"
import script from "./ModelSetting.vue?vue&type=script&lang=js&"
export * from "./ModelSetting.vue?vue&type=script&lang=js&"
import style0 from "./ModelSetting.vue?vue&type=style&index=0&id=a4610324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4610324",
  null
  
)

export default component.exports